import { PATH_NAME_PRIVACY_AGREEMENT, PATH_NAME_SIGN_UP_TERMS } from '@/common/resources/router.const'

export default [
  {
    path: '/terms/privacy_agreement',
    name: PATH_NAME_PRIVACY_AGREEMENT,
    alias: '/terms/privacy_agreement.html',
    components: {
      terms: () => import(/* webpackChunkName: "privacy_agreement" */'@/pages/terms/privacy_agreement')
    }
  },
  {
    path: '/terms/sign_up_agreement',
    name: PATH_NAME_SIGN_UP_TERMS,
    alias: '/terms/sign_up_agreement.html',
    components: {
      terms: () => import(/* webpackChunkName: "sign_up_agreement" */'@/pages/terms/sign_up_agreement')
    }
  }
]
